import React, { CSSProperties } from "react";
import { useSelector } from "react-redux";
import { Grid, Menu } from "antd";
import { Link } from "react-router-dom";

import { RootState } from "../../../app/store";
import { REACT_LOGIN_URL, REACT_LOGOUT_URL } from "../../../app/settings";
import { loggedIn } from "../../authentication/authenticationSlice";

export default () => {
  const { user, nonResearcherSFUComputingID } = useSelector(
    (state: RootState) => state.authentication
  );
  const screens = Grid.useBreakpoint();
  const breakpoint = screens.md;

  const about = (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.sfu.ca/research/researcher-resources/resources/research-expertise-engine.html"
    >
      About
    </a>
  );

  const menuStyle: CSSProperties = breakpoint
    ? { verticalAlign: 'top', padding: '0 6vw', display: 'flex' }
    : {};

  const menuMode = breakpoint ? 'horizontal' : 'vertical';

  return (
    <Menu
      theme="dark"
      mode={menuMode}
      className="login-controller sub-heading-font"
      selectable={false}
      style={menuStyle}
    >
      <Menu.Item key="about">{about}</Menu.Item>

      {!breakpoint && <Menu.Divider />}

      {/* Not logged in */}
      {!loggedIn && (
        <Menu.Item key="login" style={{ marginLeft: 'auto' }}>
          <Link
            to={{
              pathname: REACT_LOGIN_URL,
              search: `?next=${window.location.pathname}`,
            }}
          >
            Login
          </Link>
        </Menu.Item>
      )}

      {/* Logged in */}
      {loggedIn && (
        <>
          {user &&
            user.preferred_first_name &&
            user.preferred_last_name &&
            user.sfu_computing_id && (
              <Menu.Item key="preferred-name" className="no-link">
                <span className="sfu-white-text">
                  {user.preferred_first_name} {user.preferred_last_name}
                </span>
              </Menu.Item>
            )}

          {!user && nonResearcherSFUComputingID && (
            <Menu.Item
              key="non-researcher-sfu-computing-id"
              className="no-link"
            >
              <span className="sfu-white-text">
                {nonResearcherSFUComputingID}
              </span>
            </Menu.Item>
          )}

          {user && (
            <>
              <Menu.Item key="my-profile">
                <Link
                  to={`/profile/${user.random_id}`}
                >
                  My Profile
                </Link>
              </Menu.Item>
              <Menu.Item key="settings">
                <Link to="/settings/general">
                  Settings
                </Link>
              </Menu.Item>
            </>
          )}

          {!breakpoint && <Menu.Divider />}

          <Menu.Item key="logout" style={{ marginLeft: 'auto' }}>
            <Link
              to={{
                pathname: REACT_LOGOUT_URL,
                search: `?next=${window.location.pathname}`,
              }}
            >
              Logout
            </Link>
          </Menu.Item>
        </>
      )}

    </Menu>
  );
};
